import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { InstallationPickerSheet } from "../installation/InstallationPickerSheet";

const PhotoCaptureCommentSheet = ({
  open,
  value,
  onChange,
  onDismiss,
  disabled = false,
}) => {
  const { t } = useTranslation();
  const [draftComment, setDraftComment] = useState(value);

  useEffect(() => {
    if (open) {
      setDraftComment(value);
    }
  }, [open, value]);

  const handleCancel = () => {
    onDismiss();
  };

  const handleValidate = () => {
    onChange(draftComment.trim());
    onDismiss();
  };

  return (
    <InstallationPickerSheet
      open={open}
      title={t("Your comment")}
      onSheetCancel={handleCancel}
      onSheetValidate={handleValidate}
      keyboardAware
    >
      <label className="photo-capture-comment-sheet-field">
        <textarea
          className="photo-capture-metadata-comment-input"
          value={draftComment}
          onChange={(event) => setDraftComment(event.target.value)}
          placeholder={t("mobile_photo_comment_placeholder")}
          disabled={disabled}
          rows={5}
        />
      </label>
    </InstallationPickerSheet>
  );
};

export default PhotoCaptureCommentSheet;
